/**
 * Created by odeds on 12/29/15.
 */

define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/api-keys/apiKeyEditView.tmpl");
    var ApiKeyIpRangesListView =  require("manager-views/data-sources/api-keys/ApiKeyIpRangesListView");

    var InputField = require("ui/input-field/InputField");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Button = require("ui/button/Button");
    var APIListSelection = require("manager-components/apiListSelection/APIListSelection");

    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var ValidationUtilities = require("utils/ValidationUtilities");

    var KpContent = require("ui.components/kpContent/kpContent");

    var CONST = {
        APP_NAME_MAX_LENGTH: 50
    };

    var ApiKeyEditView = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ApiKeyEditView = Marionette.ItemView.extend({
            className: "datasource-entity-edit-view",
            template: template,
            ui: {
                sectionKeyChoose: ".section.key-choose",
                sectionKeyDetails: ".section.key-details",
                sectionIpRestriction: ".section.ip-restriction",
                sectionKeyAuthentication: ".section.key-authentication",

                apikeyChooserContainer: ".apikey-chooser-container",
                developerNameInputContainer: ".developer-name .attribute-value",
                descContainer: ".key-description-container",
                nameInputContainer: ".name .attribute-value",
                statusToggleButtonContainer: ".status .status-container",
                advancedToggleButtonContainer: ".advanced-toggle-button-container",

                ipRestrictionToggleButtonContainer: ".ip-restriction-toggle-button-container",
                ipRestrictionListContainer: ".ip-restriction-list-container",
                ipRestrictionKpContent: ".ip-restriction-kp",

                apiKey: ".appkey .value",
                apiKeySecret: ".appSecret .value",
                accessToken: ".accesstoken .value",
                accessTokenSecret: ".accesstokenSecret .value",

                saveButtonContainer: ".button-save",
                cancelButtonContainer: ".button-cancel",

                scrollableArea: ".view-container.apikey"
            },
            uiComponents: {
                apiListSelection: {
                    type: APIListSelection,
                    options: {
                        el: "view.ui.apikeyChooserContainer",
                        value: "view._getAPIs"
                    },
                    events: {
                        "change": "_onUpdatePrivileges"
                    }
                },
                nameInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.nameInputContainer",
                        maxLength: CONST.APP_NAME_MAX_LENGTH,
                        permutation: InputField.Permutation.B,
                        inputType: InputField.prototype.InputTypeEnum.AlphaNumeric,
                        placeholder: LE.translator.translate("LEManager.appEdit.section.createApp.name.placeholder"),
                        value: "view._getName"
                    },
                    events: {
                        "change": "_onNameChange",
                        "onblur": "_onNameChange"
                    }
                },
                devNameInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.developerNameInputContainer",
                        inputType: InputField.prototype.InputTypeEnum.AlphaNumeric,
                        maxLength: CONST.APP_NAME_MAX_LENGTH,
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEManager.appEdit.section.createApp.name.placeholder"),
                        value: "view._getDeveloperName"
                    },
                    events: {
                        "change": "_onDevNameChange",
                        "onblur": "_onDevNameChange"
                    }
                },
                description: {
                    type: InlineTextarea,
                    options: {
                        container: "view.ui.descContainer",
                        permutation: InlineTextarea.PERMUTATION.A,
                        value: "view._getDescription"

                    },
                    events: {
                        "change": "_onDescriptionChange"
                    }
                },
                statusToggleButton: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.statusToggleButtonContainer",
                        transition: ToggleButton.TRANSITION.FAST,
                        checked: "view._getStatus"
                    },
                    events: {
                        "toggleButton:change": "_onStatusChange"
                    }
                },
                advancedToggleButton: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.advancedToggleButtonContainer",
                        transition: ToggleButton.TRANSITION.FAST,
                        checked: false
                    },
                    events: {
                        "toggleButton:change": "_onAdvancedChange"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.ipRestrictionKpContent",
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "ip-restriction",
                        showKPIcon: true
                    }
                },
                ipRestrictionToggleButton: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.ipRestrictionToggleButtonContainer",
                        transition: ToggleButton.TRANSITION.FAST,
                        enabled: "view.hasIpRestrictionFeature",
                        checked: "view._getIpRestrictionToggleMode"
                    },
                    events: {
                        "toggleButton:change": "_onIpRestrictionToggleButtonChange"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButtonContainer",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.ENABLED,
                        tooltip: "view._getSaveButtonTooltipMsg",
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButtonContainer",
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onCancel"
                    }
                }
            },

            initialize: function(options) {
                this.channel = options.channel;
                this.hasIpRestrictionFeature = LE.sessionManager.hasIpRestrictionFeature();
            },

            onRender: function() {
                this._bindEvents();

                this._updateApiKey();
                this._updateSections();
                this._showIpRestrictionSection();
            },

            _bindEvents: function() {
                this.listenTo(this.model, "change", this._updateApiKey);
                this.listenTo(this.channel, "api:saved", this._onApiSaved);
                this.listenTo(this, "page:closeButtonClick", this._onCancel);
            },

            _updateApiKey: function() {
                var isModelNew = this.model.isNew();
                var isAuthContainerHidden = isModelNew;
                this.ui.sectionKeyAuthentication.toggleClass("hide", isAuthContainerHidden);

                this.uiComponents.saveButton.setEnabled(this._validateSaveEnabled());
            },

            _showIpRestrictionSection: function(){
                if (this.hasIpRestrictionFeature || this.model.getIpRestrictionRanges().length > 0){
                    this.ui.sectionIpRestriction.removeClass("hide");
                    this.ui.sectionKeyChoose.addClass("with-separator");
                    if (this.model.getIpRestrictionRanges().length > 0) {
                        this._createIpRestrictionIpRangesListView();
                    }
                }
            },

            _createIpRestrictionIpRangesListView: function() {
                this._closeIpRestrictionList(true);
                this.uiComponents.host$.createAndRender("ipRestrictionIpRangeList", {
                    type : ApiKeyIpRangesListView,
                    options : {
                        container: "view.ui.ipRestrictionListContainer",
                        collection: this.model.getIpRangesCollection(),
                        model: this.model,
                        channel: this.channel,
                        ipRangesReadOnlyMode: !this.hasIpRestrictionFeature
                    }
                });
            },

            _validateSaveEnabled: function(){
               return this.model.validateChangeToPersist() && this.model.validateMandatoryFilled();
            },
            _updateSections: function() {
                var isModelNew = this.model.isNew();
                this.ui.sectionKeyAuthentication.toggle(!isModelNew);
            },

            _onUpdatePrivileges: function(componentName, eventName, key, state) {
                var privileges= this.uiComponents.apiListSelection.getPrivileges();
                this.channel.trigger("apiKey:change:privileges",privileges);
            },

            _getName: function() {
                return this.model.getName();
            },
            _onNameChange: function(componentId, eventName, name) {
                this.channel.trigger("apiKey:change:name",name);
            },

            _getDescription: function () {
                return this.model.getDescription();
            },
            _onDescriptionChange: function(componentId, eventName, description) {
                this.channel.trigger("apiKey:change:description",description);
            },

            _getDeveloperName: function () {
                return this.model.getDeveloperName();
            },
            _onDevNameChange: function(componentId, eventName, developerName) {
                this.channel.trigger("apiKey:change:developerName",developerName);
            },

            _getStatus: function () {
                return this.model.isActive();
            },
            _onStatusChange: function(componentId, eventName, activeStatus) {
                this.channel.trigger("apiKey:change:active", activeStatus);
            },

            _onAdvancedChange: function(componentId, eventName, advancedPrivilegesMode) {
                this.uiComponents.apiListSelection.setAdvanced(advancedPrivilegesMode);
            },

            _getIpRestrictionToggleMode: function() {
                return (this.model.getIpRestrictionRanges().length > 0)? true : false;
            },

            _onIpRestrictionToggleButtonChange: function(componentId, eventName, ipRestrictionEnabled) {
                if (!ipRestrictionEnabled) {
                    this._onIpRestrictionActivationDisabled();
                }
                else {
                    this._onIpRestrictionActivationEnabled();
                }
            },

            _onIpRestrictionActivationEnabled: function() {
                this.channel.trigger("apiKey:ipRestrictionActivation:enabled");
                this._createIpRestrictionIpRangesListView();
            },

            _onIpRestrictionActivationDisabled: function(){
                this.channel.trigger("apiKey:ipRestrictionActivation:disabled");
                this._closeIpRestrictionList(false);
            },

            _closeIpRestrictionList: function(force){
                if(this.uiComponents.ipRestrictionIpRangeList){
                    this.uiComponents.ipRestrictionIpRangeList.close(force);
                }
            },

            _getAPIs: function () {
                return this.model.getPrivileges();
            },

            _onSave: function() {
                if (this.model.getIpRangesServerVersionList().length > 0 && this.model.getIpRestrictionRanges().length === 0) { //before clear and saving the IP Restriction we checks if the user has saved an IP ranges list
                    LEManager.notifier.showConfirm({
                        title: LE.translator.translate('LEFramework.global.captions.are.you.sure'),
                        content: LE.translator.translate("LEManager.manager.dataSources.Api_Keys.item.ip.restriction.disabled.confirmation.msg"),
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.yes"),
                            callback: _.bind(this._onIpRangesSaveConfirm, this)
                        }
                    });
                }
                else {
                    this._onIpRangesSaveConfirm();
                }
            },

            _onIpRangesSaveConfirm: function(){
                this.channel.trigger("api:save", this.model);
            },

            _onApiSaved: function(isCreating){
                var message= LE.translator.translate("LEManager.manager.dataSources.Api_Keys.item.created");
                this._updateSections();
                this.ui.apiKey.text(this.model.getApiKey());
                this.ui.apiKeySecret.text(this.model.getApiKeySecret());
                this.ui.accessToken.text(this.model.getAccessToken());
                this.ui.accessTokenSecret.text(this.model.getAccessTokenSecret());
                this.uiComponents.saveButton.setEnabled(false);
                LEManager.notifier.showSuccess({content: message, timeToShow: 6000});
                if (isCreating){
                    this._scrollPageToBottom();
                }
            },

            _scrollPageToBottom: function() {
                var scrollBottom = this.ui.scrollableArea.scrollTop() + this.ui.scrollableArea.height();
                this.ui.scrollableArea.scrollTop(scrollBottom);
            },

            onInvalid: function(model, errors, options){
                if(_.isUndefined(errors)){
                    errors= this.model.validate();
                }
                this._hideErrors();
                if(_.isUndefined(errors)){
                    return false;
                }

                if(errors.developerID){
                    this.uiComponents.devNameInput.setError(true, errors.developerID);
                }
                if(errors.appName){
                    this.uiComponents.nameInput.setError(true, errors.appName);
                }
                if(errors.appDescription){
                    this.uiComponents.description.setError(true, errors.appDescription);
                }

                return true;
            },

            _hideErrors: function() {
                this.uiComponents.nameInput.setError(false);
                this.uiComponents.devNameInput.setError(false);
            },

            _onCancel: function() {
                this.channel.trigger("api:close");
            }



        });
    }

    LE.module("LEManager", moduleDefinition);

    return ApiKeyEditView;
});
